import { Controller } from "@hotwired/stimulus"
import * as React from 'react'
import { createRoot } from "react-dom/client";
import StudentLearningProgressTable from "../src/react/components/Assessment/Reports/StudentLearningProgressTable";

// Connects to data-controller="student-learning-progress-table"
export default class extends Controller {
  static targets = ["progressTable"];

  connect() {
    let reportData;
    try {
      reportData = JSON.parse(this.element.dataset.reportData);
    } catch (e) {
      console.error("Failed to parse reportData:", e);
      return;
    }
    if (reportData == null) {
      console.error("reportData is missing");
      return;
    }
    if (reportData.multiple_cohorts) {
      reportData = this.deduplicateRows(reportData);
    }
    createRoot(this.progressTableTarget).render(<StudentLearningProgressTable {...reportData} />);
  }

  deduplicateRows(data) {
    const uniqueRowsMap = new Map();
    for (const row of data.rows) {
      uniqueRowsMap.set(row.uid, row);
    }
    data.rows = Array.from(uniqueRowsMap.values());
    return data;
  }
}
